import { ResetPasswordFormState } from '..'
import { isValidPassword } from 'app/utils/validatePassword'

export const validateResetPasswordForm = (values: ResetPasswordFormState) => {
  const errors: Partial<ResetPasswordFormState> = {}
  if (!values.password) {
    errors.password = 'Campo richiesto'
  }

  if (!isValidPassword(values.password)) {
    errors.password = 'La password non soddisfa i requisiti'
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = 'Campo richiesto'
  }

  if (
    values.password &&
    values.password.length &&
    values.passwordConfirmation &&
    values.passwordConfirmation.length &&
    values.password !== values.passwordConfirmation
  ) {
    errors.passwordConfirmation = 'La password deve coincidere'
  }
  return errors
}
